import {
  Device,
  getDevices,
  registerDeviceToken,
} from "@/services/core-api-adapter";
import { useGlobalStore } from "@/store";
import { persistValue, retrieveValue } from "@/store/persistence";
import { BridgeEvent } from "@unu/ui-enums";
import { registerEvents } from "@unu/web-native-bridge";
import { useEffect } from "react";

export function NotificationProvider() {
  const { state } = useGlobalStore();
  const tokenFromLocalStorage = retrieveValue(
    "firebaseMessagingTokenAndDeviceInfo"
  );

  function onTokenReceived(data: any) {
    if (data?.token !== null && data?.token !== tokenFromLocalStorage) {
      persistValue("firebaseMessagingTokenAndDeviceInfo", data);
    }
  }

  useEffect(() => {
    const events = {
      [BridgeEvent.ReceiveData]: (data: any) => onTokenReceived(data),
    };

    return registerEvents(events);
  }, []);

  useEffect(() => {
    if (state.isUserLoggedIn === true) {
      const deviceToken = retrieveValue("firebaseMessagingTokenAndDeviceInfo");
      if (deviceToken !== null) {
        getDevices().then((data) => {
          const foundDevice = data.responseList.find((device: Device) => {
            return device.token === deviceToken.token;
          });
          if (!foundDevice) {
            const foundPrimaryDevice = data.responseList.find(
              (device: Device) => {
                return device.isPrimary === true;
              }
            );
            registerDeviceToken({
              token: deviceToken.token,
              make: deviceToken.make || "",
              model: deviceToken.model || "",
              isPrimary: foundPrimaryDevice ? false : true,
            });
          }
        });
      }
    }
  }, [state.isUserLoggedIn]);

  return null;
}
